import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthActions } from '@auth/store';
import { CodeNSFActions } from '@features/referentiel/actions/code-nsf.actions';
import { CodeNsfService } from '@features/referentiel/services/code-nsf.service';

@Injectable()
export class CodeNsfEffects {

    initCodeNsf$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.userProfileLoaded),
            map(() => CodeNSFActions.getCodeNSF())
        )
    );

    loadCodesNsf$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CodeNSFActions.getCodeNSF),
            switchMap(() =>
                this.codeNsfService.getAllCodesNsf().pipe(
                    map((data: any) => CodeNSFActions.getCodeNSFSuccess({ codesNSF: data.codeNsfs })),
                    catchError((error) => of(CodeNSFActions.getCodeNSFFailure({ errorMessage: error })))
                )
            )
        )
    );

    constructor(private actions$: Actions, private codeNsfService: CodeNsfService) { }
}
